export const environment = {
  production: true,
  nombre:"Homologación",
  proyecto: "funesAdmin",
  url:"https://backend.admin.funesapp.homo.telepagos.com.ar/api/admin/"
};
